import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import "swiper/css";
import "swiper/css/pagination";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination } from "swiper/modules";
import ServiceInclude from "../../component/ServiceInclude";
import { Helmet } from "react-helmet";

const Melbourne = () => {

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);


    return (
        <>

            <Helmet prioritizeSeoTags={true}>
                <meta http-equiv="content-type" content="text/html; charset=utf-8" />
                <meta name="format-detection" content="telephone=no" />
                <title>Salesforce consulting and implementation in melbourne </title>
                <meta name="viewport" content="width=device-width, initial-scale=1" />

                <meta name="description"
                    content="Codezix offers expert Salesforce consulting and implementation services in Melbourne, helping businesses streamline operations and maximize CRM potential."
                />
                <meta
                    name="keywords"
                    content="salesforce consultant in melbourne , salesforce consulting in melbourne , salesforce consulting partner in melbourne , salesforce consultants in melbourne, salesforce developer in melbourne"
                />
            </Helmet>

            <div className="service-banner top bottom">
                <div className="container">
                    <div className='explore-heading'>
                        <h2>Salesforce Consultant In Melbourne</h2>
                    </div>
                    <div className="service-img mt-4">
                        <img src={require('../../assets/images/country/melbourne.webp')} alt="Salesforce consulting melbourne" />
                    </div>
                </div>
            </div>

            <div className="container">
                <div className="row">
                    <div className="col-lg-3">
                        <ServiceInclude />
                    </div>

                    <div className="col-lg-9">
                        <div className="salesforce-service">
                            <div className="explore-heading text-left">
                                <h2>Trusted Salesforce Consultant in Melbourne for Expert Consulting &amp; Implementation</h2>
                            </div>
                            <p className="prose-lg wow fadeUp">
                                Discover top-tier Salesforce consulting and implementation services in Melbourne with
                                Codezix, your trusted Salesforce partner. As a global innovation hub and home to numerous
                                Fortune 500 companies, it offers the perfect environment for businesses to streamline
                                operations, embrace digital transformation, and scale for growth.
                            </p>
                            <p className="prose-lg wow fadeUp">
                                At Codezix, we specialize in providing expert Salesforce solutions tailored to your specific
                                business needs. Whether starting your CRM journey or optimizing an existing Salesforce
                                environment, our team offers strategic guidance, seamless implementation, and continuous
                                support to ensure your success. We understand the unique needs of Melbourne businesses and
                                create flexible solutions that grow with you.
                            </p>
                            <p className="prose-lg">Our approach starts with a detailed analysis of your current systems and processes. From
                                there, we develop a custom Salesforce strategy that aligns with your goals. Whether it’s Sales
                                Cloud, Service Cloud, Marketing Cloud, or custom app development, we ensure smooth
                                deployment, efficient customization, and ongoing user adoption support to maximize your
                                ROI.
                            </p>
                            <p className="prose-lg">Choosing Codezix as your Salesforce consultant in Melbourne means working with a team
                                focused on innovation, performance, and client satisfaction. Our consultants combine
                                technical expertise with industry knowledge to help you fully leverage Salesforce. From
                                improving customer engagement to enhancing internal operations, we design solutions for
                                long-term impact.
                            </p>
                            <p className="prose-lg">We pride ourselves on building lasting relationships with our clients. As a leading Salesforce
                                consultant in Melbourne, we provide continuous support and optimization services to ensure
                                your platform evolves with your business.
                            </p>
                            <p className="prose-lg">Experience the Codezix difference—where strategic thinking and cutting-edge Salesforce
                                implementation come together to empower your business for the future.
                            </p>
                        </div>
                        <div className='cloud-demo' >
                            <div className="explore-heading text-left">
                                <h2>Looking for Expert Salesforce Consulting Services in Melbourne?</h2>
                                <p className="prose-lg">
                                    At Codezix, we specialize in delivering expert <strong>Salesforce consulting services in Melbourne</strong>
                                    to help businesses unlock the full potential of the world’s leading CRM platform. Our
                                    certified professionals go beyond basic implementation — we work closely with you to
                                    optimize, customize, and align Salesforce with your unique business objectives.
                                </p>
                                <p className="prose-lg">With a proven track record of successful projects across various industries, we bring deep
                                    experience and practical insights to every engagement. Whether you&#39;re launching Salesforce
                                    for the first time or refining an existing setup, we focus on creating scalable, user-friendly
                                    solutions that deliver measurable results. Our strategic and collaborative approach ensures
                                    every feature supports your growth and enhances operational efficiency.</p>
                                <p className="prose-lg">
                                    What sets Codezix apart is our commitment to long-term success. We take the time to
                                    understand your business inside and out, crafting tailored strategies that drive performance
                                    and user adoption. From Sales Cloud and Service Cloud to integrations and automation, our
                                    solutions are built for flexibility and future readiness.
                                </p>
                                <p className="prose-lg">
                                    As a trusted provider of <strong>Salesforce consulting in Melbourne</strong>, we understand the local
                                    business landscape and are well-positioned to support companies of all sizes. Our consultants
                                    provide hands-on guidance, technical expertise, and ongoing support to ensure your
                                    Salesforce environment continues to evolve with your needs.
                                </p>
                                <p className="prose-lg">
                                    No matter where you are on your Salesforce journey, Codezix is ready to help you take the
                                    next step. Let us show you how smart, strategic consulting can elevate your CRM and drive
                                    meaningful impact across your organization.
                                </p>
                                <p className="prose-lg">
                                    <strong>Ready to get started?</strong> Contact one of our Account Executives today and discover how
                                    Codezix can be your partner in successful Salesforce consulting in Melbourne.
                                </p>
                            </div>
                            <div className='service-include-right mt-5'>
                                <div className='row'>
                                    <div className='col-lg-2 col-md-2 col-sm-3'>
                                        <div className='service-section-left-img country_img'>
                                            <img src={require('../../assets/images/country/consulting.webp')} alt='Salesforce implementation melbourne' />
                                        </div>
                                    </div>
                                    <div className='col-lg-10 col-md-10 col-sm-9'>
                                        <div className='service-section-right'>
                                            <h3 className="wow fadeUp"> Salesforce Consulting</h3>
                                            <p className="wow fadeUp prose-lg">
                                                Our certified developers take a personalized approach to understanding your business needs.
                                                We assess systems, optimize workflows, and deliver insights tailored to your goals—driving
                                                efficiency, improving collaboration, and ensuring your solution delivers real, measurable
                                                outcomes across the organization.
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className='service-include-right mt-5'>
                                <div className='row'>
                                    <div className='col-lg-2 col-md-2 col-sm-3'>
                                        <div className='service-section-left-img country_img'>
                                            <img src={require('../../assets/images/country/implementation.webp')} alt='Codezix Salesforce services' />
                                        </div>
                                    </div>
                                    <div className='col-lg-10 col-md-10 col-sm-9'>
                                        <div className='service-section-right'>
                                            <h3 className="wow fadeUp"> Salesforce Implementation</h3>
                                            <p className="wow fadeUp prose-lg">
                                                Unlock your business potential with expert implementation services tailored to your needs.
                                                Our certified professionals configure and customize solutions to drive innovation, streamline
                                                processes, and support growth, ensuring seamless setup, ongoing enhancements, and long-
                                                term scalability for your organization.
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className='service-include-right mt-5'>
                                <div className='row'>
                                    <div className='col-lg-2 col-md-2 col-sm-3'>
                                        <div className='service-section-left-img country_img'>
                                            <img src={require('../../assets/images/country/customization.webp')} alt='CRM solutions melbourne' />
                                        </div>
                                    </div>
                                    <div className='col-lg-10 col-md-10 col-sm-9'>
                                        <div className='service-section-right'>
                                            <h3 className="wow fadeUp">Salesforce Customization</h3>
                                            <p className="wow fadeUp prose-lg">
                                                Our certified consultants assess your business processes and deliver tailored solutions to
                                                overcome CRM challenges. We boost sales productivity, enhance cross-department
                                                alignment, and ensure maximum efficiency through customized strategies designed to
                                                support your organization’s unique goals and operations.
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {/* <div className='service-include-right mt-5'>
                                <div className='row'>
                                    <div className='col-lg-2 col-md-2 col-sm-3'>
                                        <div className='service-section-left-img country_img'>
                                            <img src={require('../../assets/images/country/development.webp')} alt='Salesforce experts melbourne' />
                                        </div>
                                    </div>
                                    <div className='col-lg-10 col-md-10 col-sm-9'>
                                        <div className='service-section-right'>
                                            <h3 className="wow fadeUp">Salesforce App Development</h3>
                                            <p className="wow fadeUp prose-lg">
                                                Break down departmental silos and boost productivity with our seamless integration services.
                                                We connect your systems—ERP, CMS, DMS, and accounting platforms—to ensure smooth
                                                data flow, improved collaboration, and enhanced operational efficiency across all areas of
                                                your organization.
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div> */}

                            <div className='service-include-right mt-5'>
                                <div className='row'>
                                    <div className='col-lg-2 col-md-2 col-sm-3'>
                                        <div className='service-section-left-img country_img'>
                                            <img src={require('../../assets/images/country/integration.webp')} alt='Salesforce partner melbourne' />
                                        </div>
                                    </div>
                                    <div className='col-lg-10 col-md-10 col-sm-9'>
                                        <div className='service-section-right'>
                                            <h3 className="wow fadeUp"> Salesforce Integration</h3>
                                            <p className="wow fadeUp prose-lg">
                                                Break down departmental silos and boost productivity with our seamless integration services.
                                                We connect your systems—ERP, CMS, DMS, and accounting platforms—to ensure smooth
                                                data flow, improved collaboration, and enhanced operational efficiency across all areas of
                                                your organization.
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className='service-include-right mt-5'>
                                <div className='row'>
                                    <div className='col-lg-2 col-md-2 col-sm-3'>
                                        <div className='service-section-left-img country_img'>
                                            <img src={require('../../assets/images/country/migration.webp')} alt='Custom Salesforce solutions' />
                                        </div>
                                    </div>
                                    <div className='col-lg-10 col-md-10 col-sm-9'>
                                        <div className='service-section-right'>
                                            <h3 className="wow fadeUp"> Salesforce Migration Services</h3>
                                            <p className="wow fadeUp prose-lg">
                                                Seamlessly migrate from your legacy system with Codezix’s expert developer services. We
                                                ensure a smooth transition while maintaining the accuracy and integrity of your customer
                                                data, minimizing disruption, and setting your business up for long-term success and growth.
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className='service-include-right mt-5'>
                                <div className='row'>
                                    <div className='col-lg-2 col-md-2 col-sm-3'>
                                        <div className='service-section-left-img country_img'>
                                            <img src={require('../../assets/images/country/support.webp')} alt='Salesforce consulting melbourne' />
                                        </div>
                                    </div>
                                    <div className='col-lg-10 col-md-10 col-sm-9'>
                                        <div className='service-section-right'>
                                            <h3 className="wow fadeUp">Salesforce Support</h3>
                                            <p className="wow fadeUp prose-lg">
                                                With proactive system monitoring, we identify and resolve potential issues before they escalate. By minimizing downtime and ensuring smooth operations, we safeguard your business from major disruptions.
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='client-section'>
                            <div className='explore-heading text-left'>
                                <h2>Our Salesforce Certified Team In Melbourne</h2>
                            </div>
                            <p className="prose-lg">At Codezix, we bring deep expertise and a results-driven mindset to every project. As a
                                trusted <strong>Salesforce consulting partner in Melbourne</strong>, we tailor CRM solutions that align
                                with your business goals and industry needs. Our consultants are skilled in configuration,
                                customization, and system integration, ensuring you to get the most out of your investment.
                                Whether you’re optimizing processes or scaling operations, our team is committed to
                                delivering value at every stage. Partner with a proven <strong>Salesforce consulting partner in
                                    Melbourne</strong> and experience the difference a dedicated, local team can make for your success.</p>
                            <div className='row top'>
                                <Swiper
                                    breakpoints={{
                                        425: {
                                            slidesPerView: 2,
                                            spaceBetween: 10,
                                        },
                                        640: {
                                            slidesPerView: 3,
                                            spaceBetween: 10,
                                        },
                                        768: {
                                            slidesPerView: 4,
                                            spaceBetween: 30,
                                        },
                                        1024: {
                                            slidesPerView: 5,
                                            spaceBetween: 30,
                                        },
                                    }}
                                    autoplay={{
                                        delay: 2500,
                                        disableOnInteraction: false,
                                    }}
                                    pagination={{
                                        clickable: true,
                                    }}
                                    modules={[Pagination, Autoplay]}
                                    className="testimonialSwiper-client"
                                >
                                    <SwiperSlide className="col-md-4 col-4">
                                        <div className='client-image-slide-partnerships salesforce_certificate'>
                                            <img src="https://d1087d7tlbvhw9.cloudfront.net/winklixi/salesforce/4.webp" alt='Salesforce implementation melbourne' />
                                        </div>
                                    </SwiperSlide>
                                    <SwiperSlide className="col-md-4 col-4">
                                        <div className='client-image-slide-partnerships salesforce_certificate'>
                                            <img src="https://d1087d7tlbvhw9.cloudfront.net/winklixi/salesforce/1.webp" alt='Codezix Salesforce services' />
                                        </div>
                                    </SwiperSlide>
                                    <SwiperSlide className="col-md-4 col-4">
                                        <div className='client-image-slide-partnerships salesforce_certificate'>
                                            <img src="https://d1087d7tlbvhw9.cloudfront.net/winklixi/salesforce/2.webp" alt='CRM solutions melbourne' />
                                        </div>
                                    </SwiperSlide>

                                    <SwiperSlide className="col-md-4 col-4">
                                        <div className='client-image-slide-partnerships salesforce_certificate'>
                                            <img src="https://d1087d7tlbvhw9.cloudfront.net/winklixi/salesforce/3.webp" alt='Salesforce experts melbourne' />
                                        </div>
                                    </SwiperSlide>
                                    <SwiperSlide className="col-md-4 col-4">
                                        <div className='client-image-slide-partnerships salesforce_certificate'>
                                            <img src="https://d1087d7tlbvhw9.cloudfront.net/winklixi/salesforce/5.webp" alt='Salesforce partner melbourne' />
                                        </div>
                                    </SwiperSlide>
                                    <SwiperSlide className="col-md-4 col-4">
                                        <div className='client-image-slide-partnerships salesforce_certificate'>
                                            <img src="https://d1087d7tlbvhw9.cloudfront.net/winklixi/salesforce/6.webp" alt='Custom Salesforce solutions' />
                                        </div>
                                    </SwiperSlide>
                                    <SwiperSlide className="col-md-4 col-4">
                                        <div className='client-image-slide-partnerships salesforce_certificate'>
                                            <img src="https://d1087d7tlbvhw9.cloudfront.net/winklixi/salesforce/7.webp" alt='Salesforce consulting melbourne' />
                                        </div>
                                    </SwiperSlide>

                                </Swiper>
                            </div>
                        </div>

                        <div className="salesforce-product">
                            <div className='explore-heading text-left'>
                                <h2>Our Expertise in Salesforce Clouds</h2>
                                <p className="wow fadeUp prose-lg text-left">
                                    We specialize in delivering customized solutions across all Salesforce Clouds, including
                                    Sales Cloud, Service Cloud, Marketing Cloud, and Experience Cloud. Our certified experts
                                    collaborate closely with businesses to optimize each platform, ensuring enhanced efficiency,
                                    engagement, and growth. As a leading <strong>Salesforce developer in Melbourne</strong>, we tailor
                                    Salesforce environments to meet specific business needs, enabling streamlined processes and
                                    improved user experiences. Whether automating workflows or integrating systems, our
                                    <strong>Salesforce developers in Melbourne</strong> ensure your solutions align with your goals, setting
                                    you up for sustained success and scalability.
                                </p>
                            </div>
                            <div class="row mt-5">
                                <div class="col-sm-3">
                                    <div class="software-develop salesf-box height-100">
                                        <Link to="/salesforce/sales-cloud">
                                            <h3 class="mt-0">Sales Cloud</h3>
                                            <i class="fa fa-long-arrow-right arrow-icon" aria-hidden="true"></i>
                                        </Link>
                                    </div>
                                </div>
                                <div class="col-sm-3">
                                    <div class="software-develop salesf-box height-100">
                                        <Link to="/salesforce/service-cloud">
                                            <h3 class="mt-0">Service Cloud</h3>
                                            <i class="fa fa-long-arrow-right arrow-icon" aria-hidden="true"></i>
                                        </Link>
                                    </div>
                                </div>
                                <div class="col-sm-3">
                                    <div class="software-develop salesf-box height-100">
                                        <Link to="/salesforce/marketing-cloud">
                                            <h3 class="mt-0">Marketing Cloud</h3>
                                            <i class="fa fa-long-arrow-right arrow-icon" aria-hidden="true"></i>
                                        </Link>
                                    </div>
                                </div>
                                <div class="col-sm-3">
                                    <div class="software-develop salesf-box height-100">
                                        <Link to="/salesforce/community-cloud">
                                            <h3 class="mt-0">Community Cloud</h3>
                                            <i class="fa fa-long-arrow-right arrow-icon" aria-hidden="true"></i>
                                        </Link>
                                    </div>
                                </div>
                                <div class="col-sm-3">
                                    <div class="software-develop salesf-box height-100">
                                        <Link to="/salesforce/finencial-service-cloud">
                                            <h3 class="mt-0">Financial Services Cloud</h3>
                                            <i class="fa fa-long-arrow-right arrow-icon" aria-hidden="true"></i>
                                        </Link>
                                    </div>
                                </div>
                                <div class="col-sm-3">
                                    <div class="software-develop salesf-box height-100">
                                        <Link to="/salesforce/non-profit">
                                            <h3 class="mt-0">Nonprofit Cloud</h3>
                                            <i class="fa fa-long-arrow-right arrow-icon" aria-hidden="true"></i>
                                        </Link>
                                    </div>
                                </div>
                                <div class="col-sm-3">
                                    <div class="software-develop salesf-box height-100">
                                        <Link to="/salesforce/cpq">
                                            <h3 class="mt-0">Salesforce CPQ</h3>
                                            <i class="fa fa-long-arrow-right arrow-icon" aria-hidden="true"></i>
                                        </Link>
                                    </div>
                                </div>
                                <div class="col-sm-3">
                                    <div class="software-develop salesf-box height-100">
                                        <Link to="/salesforce/development-company-in-melbourne#">
                                            <h3 class="mt-0">Salesforce Chatter</h3>
                                            <i class="fa fa-long-arrow-right arrow-icon" aria-hidden="true"></i>
                                        </Link>
                                    </div>
                                </div>
                                <div class="col-sm-3">
                                    <div class="software-develop salesf-box height-100">
                                        <Link to="/salesforce/community-cloud">
                                            <h3 class="mt-0">Community Cloud</h3>
                                            <i class="fa fa-long-arrow-right arrow-icon" aria-hidden="true"></i>
                                        </Link>
                                    </div>
                                </div>
                                <div class="col-sm-3">
                                    <div class="software-develop salesf-box height-100">
                                        <Link to="/salesforce/einstein-analytics">
                                            <h3 class="mt-0">Einstein Analytics</h3>
                                            <i class="fa fa-long-arrow-right arrow-icon" aria-hidden="true"></i>
                                        </Link>
                                    </div>
                                </div>
                                <div class="col-sm-3">
                                    <div class="software-develop salesf-box height-100">
                                        <Link to="/salesforce/development-company-in-melbourne#">
                                            <h3 class="mt-0">Salesforce Lightning</h3>
                                            <i class="fa fa-long-arrow-right arrow-icon" aria-hidden="true"></i>
                                        </Link>
                                    </div>
                                </div>
                                <div class="col-sm-3">
                                    <div class="software-develop salesf-box height-100">
                                        <Link to="/salesforce/development-company-in-melbourne#">
                                            <h3 class="mt-0">Health Cloud</h3>
                                            <i class="fa fa-long-arrow-right arrow-icon" aria-hidden="true"></i>
                                        </Link>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="salesforce-product">
                            <div className='explore-heading text-left'>
                                <h2>Industries We Support as a Trusted Salesforce Consultant in Melbourne</h2>
                                <p className="prose-lg">We offer tailored Salesforce solutions across industries, helping businesses improve customer
                                    relationships, streamline operations, and drive growth. Our Salesforce consultants in
                                    Melbourne bring expertise to various sectors like retail, healthcare, finance, and
                                    manufacturing. By maximizing Salesforce’s capabilities, we deliver customized strategies
                                    that address unique industry needs. From automating workflows to enhancing sales and
                                    customer service, our Salesforce consultants in Melbourne ensure your business thrives
                                    with efficient, innovative solutions that foster long-term success and operational excellence.
                                    Let us unlock Salesforce’s potential for your business.
                                </p>
                            </div>

                            <div class="row mob-imagebox">
                                <div class="col-sm-4">
                                    <div class="blg">
                                        <img src="https://d1087d7tlbvhw9.cloudfront.net/winklixi/salesforce/industry/healthcare.webp" alt="Salesforce implementation melbourne" />
                                        <div class="image-text">
                                            <p>Healthcare</p>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-sm-4">
                                    <div class="blg">
                                        <img src="https://d1087d7tlbvhw9.cloudfront.net/winklixi/salesforce/industry/retail.webp" alt="Codezix Salesforce services" />
                                        <div class="image-text">
                                            <p>E-Commerce</p>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-sm-4">
                                    <div class="blg">
                                        <img src="https://d1087d7tlbvhw9.cloudfront.net/winklixi/salesforce/industry/logistics.webp" alt="CRM solutions melbourne" />
                                        <div class="image-text">
                                            <p>Logistics</p>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-sm-4">
                                    <div class="blg">
                                        <img src="https://d1087d7tlbvhw9.cloudfront.net/winklixi/salesforce/industry/financial.webp" alt="Salesforce experts melbourne" />
                                        <div class="image-text">
                                            <p>Financial</p>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-sm-4">
                                    <div class="blg">
                                        <img src="https://d1087d7tlbvhw9.cloudfront.net/winklixi/salesforce/industry/manufacturing.webp" alt="Salesforce partner melbourne" />
                                        <div class="image-text">
                                            <p>Manufacturing</p>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-sm-4">
                                    <div class="blg">
                                        <img src="https://d1087d7tlbvhw9.cloudfront.net/winklixi/salesforce/industry/publicsector.webp" alt="Custom Salesforce solutions" />
                                        <div class="image-text">
                                            <p>Public Sector</p>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-sm-4">
                                    <div class="blg">
                                        <img src="https://d1087d7tlbvhw9.cloudfront.net/winklixi/salesforce/industry/media.webp" alt="Salesforce consulting melbourne" />
                                        <div class="image-text">
                                            <p>Media</p>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-sm-4">
                                    <div class="blg">
                                        <img src="https://d1087d7tlbvhw9.cloudfront.net/winklixi/salesforce/industry/it.webp" alt="Salesforce implementation melbourne" />
                                        <div class="image-text">
                                            <p>IT Industry</p>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-sm-4">
                                    <div class="blg">
                                        <img src="https://d1087d7tlbvhw9.cloudfront.net/winklixi/salesforce/industry/telecom.webp" alt="Codezix Salesforce services" />
                                        <div class="image-text">
                                            <p>Telecom</p>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-sm-4">
                                    <div class="blg">
                                        <img src="https://d1087d7tlbvhw9.cloudfront.net/winklixi/salesforce/industry/education.webp" alt="CRM solutions melbourne" />
                                        <div class="image-text">
                                            <p>Education</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="salesforce-product">
                            <div className='explore-heading text-left'>
                                <h2>Why work with Codezix ?</h2>
                            </div>

                            <div className="row bottom">
                                <div className="col-lg-6">
                                    <div className="why-listing mt-4">
                                        <ul>
                                            <li className="wow fadeUp prose-lg">Certified Salesforce Consulting Partner</li>
                                            <li className="wow fadeUp prose-lg">80+ skilled developers with over 300 certifications</li>
                                            <li className="wow fadeUp prose-lg">89% repeat business rate, showcasing client trust</li>
                                            <li className="wow fadeUp prose-lg">90% client retention rate, building lasting relationships</li>
                                            <li className="wow fadeUp prose-lg">More than 10 years of industry expertise</li>
                                        </ul>
                                    </div>
                                </div>
                                <div className="col-lg-6">
                                    <div className="why-listing mt-4">
                                        <ul>
                                            <li className="wow fadeUp prose-lg">Comprehensive End-to-End Support & Maintenance</li>
                                            <li className="wow fadeUp prose-lg">24/7 global Salesforce support, available across all time zones</li>
                                            <li className="wow fadeUp prose-lg">100% in-house development, guaranteeing top-tier quality control</li>
                                            <li className="wow fadeUp prose-lg">99% on-time project delivery, ensuring flawless execution</li>
                                            <li className="wow fadeUp prose-lg">Thorough testing for reliable, high-performance Salesforce solutions</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='cloud-demo' >
                            <div className='explore-heading text-left'>
                                <h2>Customer Success Stories</h2>
                            </div>

                            <div className='service-include-right mt-5'>
                                <div className='row'>
                                    <div className='col-lg-3 col-md-3 col-sm-4'>
                                        <div className='service-section-left-img country_img'>
                                            <img src="https://d1087d7tlbvhw9.cloudfront.net/winklixi/winklixwebsite/casestudy/salesforce/images/pd1.webp" alt='Codezix Salesforce services' />
                                        </div>
                                    </div>
                                    <div className='col-lg-9 col-md-9 col-sm-8'>
                                        <div className='service-section-right'>
                                            <h3 className="wow fadeUp">3 PL Central </h3>
                                            <p className="wow fadeUp prose-lg">
                                                Based in California, <strong>3PL Central</strong> provides a state-of-the-art warehouse management system (WMS) that streamlines operations, enhances customer satisfaction, and drives business growth.
                                            </p>
                                        </div>
                                        {/* <div className="services_button_right">
                                            <Link to="" ></Link>
                                        </div> */}
                                    </div>
                                </div>
                            </div>

                            <div className='service-include-right mt-5'>
                                <div className='row'>
                                    <div className='col-lg-3 col-md-3 col-sm-4'>
                                        <div className='service-section-left-img country_img'>
                                            <img src="https://d1087d7tlbvhw9.cloudfront.net/winklixi/winklixwebsite/casestudy/salesforce/images/24-Fit-Club1.webp" alt='CRM solutions melbourne' />
                                        </div>
                                    </div>
                                    <div className='col-lg-9 col-md-9 col-sm-8'>
                                        <div className='service-section-right'>
                                            <h3 className="wow fadeUp">24 Fit Club </h3>
                                            <p className="wow fadeUp prose-lg">
                                                Located in the UK, <strong>24 Fit Club</strong> is a vibrant fitness community committed to enhancing health and well-being. Their expert team offers top-tier fitness coaching, online classes, and innovative insights to inspire clients and encourage body positivity.
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className='service-include-right mt-5'>
                                <div className='row'>
                                    <div className='col-lg-3 col-md-3 col-sm-4'>
                                        <div className='service-section-left-img country_img'>
                                            <img src="https://d1087d7tlbvhw9.cloudfront.net/winklixi/winklixwebsite/casestudy/salesforce/images/salesforce1.webp" alt='Salesforce experts melbourne' />
                                        </div>
                                    </div>
                                    <div className='col-lg-9 col-md-9 col-sm-8'>
                                        <div className='service-section-right'>
                                            <h3 className="wow fadeUp">Active Campaign </h3>
                                            <p className="wow fadeUp prose-lg">
                                                Salesforce is a robust CRM platform that provides a comprehensive enterprise solution, accessible across multiple devices. Its dynamic app marketplace strengthens marketing and sales collaboration, boosting lead generation and cultivating high-quality pipelines.
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className='service-include-right mt-5'>
                                <div className='row'>
                                    <div className='col-lg-3 col-md-3 col-sm-4'>
                                        <div className='service-section-left-img country_img'>
                                            <img src="https://d1087d7tlbvhw9.cloudfront.net/winklixi/winklixwebsite/casestudy/salesforce/images/advologix.webp" alt='Salesforce partner melbourne' />
                                        </div>
                                    </div>
                                    <div className='col-lg-9 col-md-9 col-sm-8'>
                                        <div className='service-section-right'>
                                            <h3 className="wow fadeUp">Advologix</h3>
                                            <p className="wow fadeUp prose-lg">
                                                Headquartered in Sugarland, Texas, Advologix is a digital consultancy specializing in legal document and case management. They help law firms, legal departments, and public service organizations streamline case processing through centralized information management systems.
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className='service-include-right mt-5'>
                                <div className='row'>
                                    <div className='col-lg-3 col-md-3 col-sm-4'>
                                        <div className='service-section-left-img country_img'>
                                            <img src="https://d1087d7tlbvhw9.cloudfront.net/winklixi/winklixwebsite/casestudy/salesforce/images/concert_health.webp" alt='Custom Salesforce solutions' />
                                        </div>
                                    </div>
                                    <div className='col-lg-9 col-md-9 col-sm-8'>
                                        <div className='service-section-right'>
                                            <h3 className="wow fadeUp">Concert Health</h3>
                                            <p className="wow fadeUp prose-lg">
                                                Concert Health supports physician practices in integrating behavioral health services, such as care management, brief therapy, and psychiatric consultations. With a team of expert clinicians, valuable industry insights, and cutting-edge technology, they enhance patient care and drive better outcomes.
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className='service-include-right mt-5'>
                                <div className='row'>
                                    <div className='col-lg-3 col-md-3 col-sm-4'>
                                        <div className='service-section-left-img country_img'>
                                            <img src="https://d1087d7tlbvhw9.cloudfront.net/winklixi/winklixwebsite/casestudy/salesforce/images/at-home-solutions.webp" alt='Salesforce consulting melbourne' />
                                        </div>
                                    </div>
                                    <div className='col-lg-9 col-md-9 col-sm-8'>
                                        <div className='service-section-right'>
                                            <h3 className="wow fadeUp">At Home Solutions</h3>
                                            <p className="wow fadeUp prose-lg">
                                                Based in Melbourne, At Home Solutions provides personalized healthcare services designed to enhance the quality of life for individuals of all ages. With over a decade of experience, they offer affordable, effective care, including companionship, customized support, and essential medical services.
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='cloud-demo' >
                            <div className='explore-heading text-left'>
                                <h2>Customer Success Stories</h2>
                            </div>

                            <div className='service-include-right mt-5'>
                                <div className='row'>
                                    <div className='col-lg-3 col-md-3 col-sm-4'>
                                        <div className='service-section-left-img country_img'>
                                            <img src="https://d1087d7tlbvhw9.cloudfront.net/winklixi/salesforce/blog/commerce.webp" alt='Salesforce implementation melbourne' />
                                        </div>
                                    </div>
                                    <div className='col-lg-9 col-md-9 col-sm-8'>
                                        <div className='service-section-right'>
                                            <h3 className="wow fadeUp">Salesforce Commerce Cloud: Everything You Need to Know</h3>
                                            <p className="wow fadeUp prose-lg">
                                                In today's digital landscape, e-commerce is crucial for business success and fuels intense competition. As online shopping demand continues to rise, businesses must implement scalable, innovative solutions to stay ahead of the curve and meet ever-changing consumer expectations.
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className='service-include-right mt-5'>
                                <div className='row'>
                                    <div className='col-lg-3 col-md-3 col-sm-4'>
                                        <div className='service-section-left-img country_img'>
                                            <img src="https://d1087d7tlbvhw9.cloudfront.net/winklixi/salesforce/blog/agent.webp" alt='CRM solutions melbourne' />
                                        </div>
                                    </div>
                                    <div className='col-lg-9 col-md-9 col-sm-8'>
                                        <div className='service-section-right'>
                                            <h3 className="wow fadeUp"> Ultimate Guide to Salesforce Agentforce</h3>
                                            <p className="wow fadeUp prose-lg">
                                                A key highlight of 2025 is Salesforce Agentforce. On Day Three of Dreamforce 2024, Salesforce unveiled Agentforce, a groundbreaking AI-powered tool designed to enhance employee productivity.
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className='service-include-right mt-5'>
                                <div className='row'>
                                    <div className='col-lg-3 col-md-3 col-sm-4'>
                                        <div className='service-section-left-img country_img'>
                                            <img src="https://d1087d7tlbvhw9.cloudfront.net/winklixi/salesforce/blog/marketing.webp" alt='Salesforce experts melbourne' />
                                        </div>
                                    </div>
                                    <div className='col-lg-9 col-md-9 col-sm-8'>
                                        <div className='service-section-right'>
                                            <h3 className="wow fadeUp">
                                                Understanding Salesforce MuleSoft & How Codezix Supports Implementation & Customization
                                            </h3>
                                            <p className="wow fadeUp prose-lg">
                                                In today’s digital landscape, businesses utilize various applications and platforms to streamline operations and enhance customer experiences. However, achieving seamless integration can be a challenge—this is where Salesforce MuleSoft becomes essential.
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div >
        </>
    )
}

export default Melbourne;